/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ServiceAreaAndType } from "./ServiceAreaAndType";
import {
  ServiceAreaAndTypeFromJSON,
  ServiceAreaAndTypeFromJSONTyped,
  ServiceAreaAndTypeToJSON,
  ServiceAreaAndTypeToJSONTyped,
} from "./ServiceAreaAndType";
import type { ShipmentCoverage } from "./ShipmentCoverage";
import {
  ShipmentCoverageFromJSON,
  ShipmentCoverageFromJSONTyped,
  ShipmentCoverageToJSON,
  ShipmentCoverageToJSONTyped,
} from "./ShipmentCoverage";

/**
 *
 * @export
 * @interface CarrierCoverageResult
 */
export interface CarrierCoverageResult {
  /**
   *
   * @type {string}
   * @memberof CarrierCoverageResult
   */
  carrierIdentifier: string;
  /**
   *
   * @type {Array<ShipmentCoverage>}
   * @memberof CarrierCoverageResult
   */
  shipmentCoverages: Array<ShipmentCoverage>;
  /**
   *
   * @type {Array<ServiceAreaAndType>}
   * @memberof CarrierCoverageResult
   */
  serviceAreas: Array<ServiceAreaAndType>;
  /**
   *
   * @type {Array<ShipmentCoverage>}
   * @memberof CarrierCoverageResult
   */
  coveredShipments: Array<ShipmentCoverage>;
  /**
   *
   * @type {Array<ShipmentCoverage>}
   * @memberof CarrierCoverageResult
   */
  uncoveredShipments: Array<ShipmentCoverage>;
  /**
   *
   * @type {number}
   * @memberof CarrierCoverageResult
   */
  coveredCount: number;
  /**
   *
   * @type {number}
   * @memberof CarrierCoverageResult
   */
  uncoveredCount: number;
  /**
   *
   * @type {number}
   * @memberof CarrierCoverageResult
   */
  totalCount: number;
  /**
   *
   * @type {number}
   * @memberof CarrierCoverageResult
   */
  rate: number;
}

/**
 * Check if a given object implements the CarrierCoverageResult interface.
 */
export function instanceOfCarrierCoverageResult(
  value: object,
): value is CarrierCoverageResult {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (
    !("shipmentCoverages" in value) ||
    value["shipmentCoverages"] === undefined
  )
    return false;
  if (!("serviceAreas" in value) || value["serviceAreas"] === undefined)
    return false;
  if (!("coveredShipments" in value) || value["coveredShipments"] === undefined)
    return false;
  if (
    !("uncoveredShipments" in value) ||
    value["uncoveredShipments"] === undefined
  )
    return false;
  if (!("coveredCount" in value) || value["coveredCount"] === undefined)
    return false;
  if (!("uncoveredCount" in value) || value["uncoveredCount"] === undefined)
    return false;
  if (!("totalCount" in value) || value["totalCount"] === undefined)
    return false;
  if (!("rate" in value) || value["rate"] === undefined) return false;
  return true;
}

export function CarrierCoverageResultFromJSON(
  json: any,
): CarrierCoverageResult {
  return CarrierCoverageResultFromJSONTyped(json, false);
}

export function CarrierCoverageResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierCoverageResult {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    shipmentCoverages: (json["shipmentCoverages"] as Array<any>).map(
      ShipmentCoverageFromJSON,
    ),
    serviceAreas: (json["serviceAreas"] as Array<any>).map(
      ServiceAreaAndTypeFromJSON,
    ),
    coveredShipments: (json["coveredShipments"] as Array<any>).map(
      ShipmentCoverageFromJSON,
    ),
    uncoveredShipments: (json["uncoveredShipments"] as Array<any>).map(
      ShipmentCoverageFromJSON,
    ),
    coveredCount: json["coveredCount"],
    uncoveredCount: json["uncoveredCount"],
    totalCount: json["totalCount"],
    rate: json["rate"],
  };
}

export function CarrierCoverageResultToJSON(json: any): CarrierCoverageResult {
  return CarrierCoverageResultToJSONTyped(json, false);
}

export function CarrierCoverageResultToJSONTyped(
  value?: CarrierCoverageResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    shipmentCoverages: (value["shipmentCoverages"] as Array<any>).map(
      ShipmentCoverageToJSON,
    ),
    serviceAreas: (value["serviceAreas"] as Array<any>).map(
      ServiceAreaAndTypeToJSON,
    ),
    coveredShipments: (value["coveredShipments"] as Array<any>).map(
      ShipmentCoverageToJSON,
    ),
    uncoveredShipments: (value["uncoveredShipments"] as Array<any>).map(
      ShipmentCoverageToJSON,
    ),
    coveredCount: value["coveredCount"],
    uncoveredCount: value["uncoveredCount"],
    totalCount: value["totalCount"],
    rate: value["rate"],
  };
}
